import { Dispatch, SetStateAction } from 'react'
import { createUninitializedContext } from '@crew/utils/context'

/** Context用の型 */
type EventDetailPageContextType = {
  confirmAttendance: boolean
  setConfirmAttendance: Dispatch<SetStateAction<boolean>>
  selectedEventRecordingTranscribes: SelectedEventRecordingTranscribe[] // 選択された文字起こしのリスト
  setSelectedEventRecordingTranscribes: Dispatch<
    SetStateAction<SelectedEventRecordingTranscribe[]>
  >
}

// 選択した文字起こしの行データを扱う型定義
export type SelectedEventRecordingTranscribe = {
  id: string
  version: number
}

/** Context */
const {
  context: eventDetailPageContext,
  useInitializedContext: useEventDetailPageContext,
} = createUninitializedContext<EventDetailPageContextType>()

export { useEventDetailPageContext }
// export const EventDetailPageContext =
//   createContext<EventDetailPageContextType>(undefined!)

export const useEventDetailPage = () => {
  return {
    eventDetailPageContext,
  }
}
